const DRIVE_ITEM_LIST_PAGE_SIZE = 20;

enum ListDisplayType {
	Default = 'Default', // use display type which is set in backoffice
	Grid = 'Grid',
	Row = 'Row',
	Masonry = 'Masonry',
	Coverflow = 'Coverflow',
}

export { DRIVE_ITEM_LIST_PAGE_SIZE, ListDisplayType };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemList/constants.ts